// extracted by mini-css-extract-plugin
module.exports = {"modal":"Ei","error":"Fi","disabled":"Gi","fields":"Hi","header":"Ii","footer":"Ji"};